var colors = {
  aqua: {
    r: 0,
    g: 255,
    b: 255
  },
  black: {
    r: 0,
    g: 0,
    b: 0
  },
  blue: {
    r: 0,
    g: 0,
    b: 255
  },
  fuchsia: {
    r: 255,
    g: 0,
    b: 255
  },
  gray: {
    r: 128,
    g: 128,
    b: 128
  },
  green: {
    r: 0,
    g: 128,
    b: 0
  },
  lime: {
    r: 0,
    g: 255,
    b: 0
  },
  maroon: {
    r: 128,
    g: 0,
    b: 0
  },
  navy: {
    r: 0,
    g: 0,
    b: 128
  },
  olive: {
    r: 128,
    g: 128,
    b: 0
  },
  purple: {
    r: 128,
    g: 0,
    b: 128
  },
  red: {
    r: 255,
    g: 0,
    b: 0
  },
  silver: {
    r: 192,
    g: 192,
    b: 192
  },
  teal: {
    r: 0,
    g: 128,
    b: 128
  },
  white: {
    r: 255,
    g: 255,
    b: 255
  },
  yellow: {
    r: 255,
    g: 255,
    b: 0
  },
  transparent: {
    r: 0,
    g: 0,
    b: 0,
    a: 0
  }
};

export default colors;
